// src/components/layout/AdminShell.tsx
import React from 'react';

type Props = {
  children: React.ReactNode;
  isDarkMode?: boolean;
};

const AdminShell: React.FC<Props> = ({ children, isDarkMode }) => {
  return (
    <section
      data-roddo-admin-shell="true"
      data-roddo-theme={isDarkMode ? 'dark' : 'light'}
      style={{ colorScheme: isDarkMode ? 'dark' : 'light' }}
      className={[
        'roddo-admin-root',
        isDarkMode ? 'dark' : '',
        'relative min-h-full w-full overflow-hidden',
        'bg-[#F7EFE6] text-[#22313A]',
        'dark:bg-[#070B15] dark:text-[#F2F6FC]',
      ].join(' ')}
    >
      

      <main className="relative z-10 mx-auto w-full max-w-[1480px] px-3 pb-[calc(var(--roddo-nav-h,72px)+28px)] pt-4 sm:px-4 lg:pb-8">
        {children}
      </main>
    </section>
  );
};

export default AdminShell;
